import './shared/utils/Reactotron/ReactotronConfig';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { setI18nConfig } from './shared/translations';
import configureStore from './configureStore';
import './index.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import { USER_LOCALE } from './shared/constants/LocalStorageKeys/LocalStorageKeys';

const { store } = configureStore();
const userLocale = localStorage.getItem(USER_LOCALE);
setI18nConfig(userLocale || 'en');
/* istanbul ignore next */
ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('nav-root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
